import { LinkList } from '@eika/link-list';

import './useful-info-link-list.scss';
import { useLinks } from '@hooks/use-links';
import { useTranslation } from '@translations';

export const UsefulInfoLinkList = () => {
    const { usefulInfo } = useTranslation();
    const { header, aboutAskForChild, getAnOverviewOfTheSaving, howToCreateAManagedAccount } = usefulInfo;
    const links = useLinks();

    return (
        <section aria-labelledby="useful-info-title">
            <h2 id="useful-info-title" className="heading">
                {header}
            </h2>
            <LinkList className="link-list" data-testid="useful-info-links">
                <LinkList.Item href={links.aboutSavingInfo.url}>{aboutAskForChild}</LinkList.Item>
                <LinkList.Item href={links.overviewOfSavingInfo.url}>{getAnOverviewOfTheSaving}</LinkList.Item>
                <LinkList.Item href={links.howToCreateInfo.url}>{howToCreateAManagedAccount}</LinkList.Item>
            </LinkList>
        </section>
    );
};
